export const cellMaxLength = 254;
export const rangeMaxLength = 28;
export const savedReportCellMaxLength = 254;
export const savedReportRangeMaxLength = 28;
export const textIdDebounceTime = 500;
